module.exports = __webpack_public_path__ + "img/rechazado.998db9e1.svg";